import { render, staticRenderFns } from "./Coparticipation.vue?vue&type=template&id=495da542&"
import script from "./Coparticipation.vue?vue&type=script&lang=js&"
export * from "./Coparticipation.vue?vue&type=script&lang=js&"
import style0 from "./Coparticipation.vue?vue&type=style&index=0&id=495da542&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports